import { BigNumber } from "ethers";
import { formatUnits } from "ethers/lib/utils";

const bigNumberToFloat = (bigNumber: BigNumber, decimalToParse?: number): number => {
  const numberString = formatUnits(bigNumber, decimalToParse);
  return parseFloat(numberString);
};

export default bigNumberToFloat;
